webpackJsonp([0],[
/* 0 */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /opt/build/repo/src/index.js */1);


/***/ }),
/* 1 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_painter__ = __webpack_require__(/*! ./scripts/painter */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scripts_painter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__scripts_painter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_painter_scss__ = __webpack_require__(/*! ./styles/painter.scss */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_painter_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_painter_scss__);



/***/ }),
/* 2 */
/*!********************************!*\
  !*** ./src/scripts/painter.js ***!
  \********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

var cPushArray = [];
var cStep = -1;
var _intervalId = void 0; // used to track the current interval ID
var _center = void 0; // the current center to spray
var canvas = document.getElementById('canvas');
var lineWidthchange = document.getElementById('lineWidthchange');
var colorchange = document.getElementById('colorchange');
var clear = document.getElementById('clear');
var selecter = document.getElementById('selecter');
var download = document.getElementById('download');
var undo = document.getElementById("undo");
var redo = document.getElementById("redo");
var spray = document.getElementById("spray");
var pen = document.getElementById("pen");
var eraser = document.getElementById("eraser");
var picker = document.getElementById("picker");
var context = canvas.getContext('2d');
var mouse = { x: 0, y: 0 };
var brushWidth = 10;
var density = 50;
var eraseron = false;
var sprayon = false;
var penon = true;
var pickeron = false;
var md = false;
var spraycolor = '#ff0000';
var brushcolor = '#ff0000';
context.lineWidth = brushWidth;
context.lineJoin = 'round';
context.lineCap = 'round';
context.strokeStyle = '#ff0000';
context.fillStyle = "white";
context.fillRect(0, 0, 600, 400);
pen.classList.add('selected');

canvas.addEventListener('mousedown', down);
canvas.addEventListener('mouseup', toggledraw);
canvas.addEventListener('mousemove', function (evt) {
  mouse.x = evt.pageX - this.offsetLeft;
  mouse.y = evt.pageY - this.offsetTop;
  draw(canvas, mouse.x, mouse.y);
});

function down() {
  if (pickeron) {

    context.strokeStyle = 'white';
    context.beginPath();
    context.moveTo(mouse.x, mouse.y);
  }
  if (eraseron) {
    md = true;
    context.strokeStyle = 'white';
    context.beginPath();
    context.moveTo(mouse.x, mouse.y);
  }
  if (penon) {
    md = true;
    context.strokeStyle = brushcolor;
    context.beginPath();
    context.moveTo(mouse.x, mouse.y);
  }
  if (sprayon) {
    timeout = setTimeout(function draw() {
      for (var i = density; i--;) {
        var angle = getRandomFloat(0, Math.PI * 2);
        var radius = getRandomFloat(0, brushWidth);
        context.fillStyle = spraycolor;
        context.fillRect(mouse.x + radius * Math.cos(angle), mouse.y + radius * Math.sin(angle), 1, 1);
      }
      timeout = setTimeout(draw, 50);
    }, 50);
  }
}

function toggledraw() {
  md = false;
  canvas.style.cursor = "default";
  cPush();
  clearTimeout(timeout);
}
function draw(canvas, posx, posy) {
  canvas.onmouseleave = function () {
    md = false;
    clearTimeout(timeout);
    console.log('good');
  };
  if (md) {
    canvas.style.cursor = "pointer";
    context.lineTo(mouse.x, mouse.y);
    context.stroke();
  };
}
// lineWidth
lineWidthchange.addEventListener("change", function (e) {
  brushWidth = e.target.value;
  context.lineWidth = brushWidth;
});
// brushStyle
colorchange.addEventListener("change", function (e) {
  brushcolor = e.target.value;
  context.strokeStyle = brushcolor;
  spraycolor = e.target.value;
  context.fillStyle = spraycolor;
});
// clear
clear.addEventListener("click", function (e) {
  context.fillStyle = "white";
  context.fillRect(0, 0, 600, 400);
});
// download
download.addEventListener('click', function () {
  downloadCanvas(this, 'canvas', 'paint');
}, false);
function downloadCanvas(link, canvasId, filename) {
  var e = selecter.options[selecter.selectedIndex].value;
  if (e === "png") link.href = document.getElementById(canvasId).toDataURL();
  link.download = filename;
  if (e === "jpg") link.href = document.getElementById(canvasId).toDataURL("image/jpeg");
  link.download = filename;
}
// Savestep
function cPush() {
  cStep++;
  if (cStep < cPushArray.length) {
    cPushArray.length = cStep;
  }
  cPushArray.push(canvas.toDataURL());
}
// Undo SLICE
undo.addEventListener("click", function () {
  if (cStep > 0) {
    cStep--;
    var canvasPic = new Image();
    canvasPic.src = cPushArray[cStep];
    canvasPic.onload = function () {
      context.drawImage(canvasPic, 0, 0);
    };
  }
});
// Redo
redo.addEventListener("click", function () {
  if (cStep < cPushArray.length - 1) {
    cStep++;
    var canvasPic = new Image();
    canvasPic.src = cPushArray[cStep];
    canvasPic.onload = function () {
      context.drawImage(canvasPic, 0, 0);
    };
  }
});

//Spray
function getRandomFloat(min, max) {
  return Math.random() * (max - min) + min;
}
spray.addEventListener("click", function () {
  penon = false;
  sprayon = true;
  eraseron = false;
  pickeron = false;
  spray.classList.add('selected');
  pen.classList.remove('selected');
  eraser.classList.remove('selected');
  picker.classList.remove('selected');
});
context.fillStyle = '#ff0000';
//pen
pen.addEventListener("click", function () {
  penon = true;
  sprayon = false;
  eraseron = false;
  pickeron = false;
  pen.classList.add('selected');
  spray.classList.remove('selected');
  eraser.classList.remove('selected');
  picker.classList.remove('selected');
});
//eraser
eraser.addEventListener("click", function () {
  eraseron = true;
  sprayon = false;
  penon = false;
  pickeron = false;
  eraser.classList.add('selected');
  spray.classList.remove('selected');
  pen.classList.remove('selected');
  picker.classList.remove('selected');
});
//picker
picker.addEventListener("click", function () {
  pickeron = true;
  sprayon = false;
  penon = false;
  eraseron = false;
  picker.classList.add('selected');
  eraser.classList.remove('selected');
  spray.classList.remove('selected');
  pen.classList.remove('selected');
});

/***/ }),
/* 3 */
/*!*********************************!*\
  !*** ./src/styles/painter.scss ***!
  \*********************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[0]);


// WEBPACK FOOTER //
// client.cf69fb6c.js